/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const careerSiteOutputDataSchema = z.object({
	organisationName: z.string(),
	organisationSlug: z.string(),
	logoUrl: z.string().nullable(),
	campaigns: z.array(
		z.object({
			id: z.string(),
			title: z.string(),
			location: z.string().nullable(),
			formId: z.string(),
			createdAt: z.iso.datetime(),
			imageUrl: z.string().nullable(),
		}),
	),
	availableLocations: z.array(z.string()),
	page: z.number(),
	perPage: z.number(),
	total: z.number(),
	hasMore: z.boolean(),
})

export type CareerSiteOutputDataSchema = z.infer<typeof careerSiteOutputDataSchema>
